module.exports = __webpack_public_path__ + "img/apk.4a1d405c.svg";